<script setup lang="ts">
import type { UserProfile } from '@factoryfixinc/ats-interfaces';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    user: Partial<UserProfile>;
    size?: 'sm' | 'lg';
  }>(),
  { size: 'sm' },
);

const avatarUrl = computed(() => props.user?.avatarUrl);
const nameFirst = computed(() => props.user?.nameFirst?.[0]);
const nameLast = computed(() => props.user?.nameLast?.[0]);
const isLarge = computed(() => props.size === 'lg');
const dimensionClass = computed(() => (isLarge.value ? 'h-14 w-14' : 'h-8 w-8'));
const initialsClass = computed(() => (isLarge.value ? 'text-base' : 'text-xs'));
</script>

<template>
  <div>
    <img
      v-if="avatarUrl"
      :width="isLarge ? 56 : 32"
      :height="isLarge ? 56 : 32"
      :src="avatarUrl"
      alt="avatar"
      class="rounded-full"
      :class="dimensionClass"
    />
    <span
      v-else
      class="avatar-text flex items-center justify-center rounded-full bg-primary-50"
      :class="dimensionClass"
    >
      <span class="font-bold text-primary-800" :class="initialsClass"
        >{{ nameFirst }}{{ nameLast }}</span
      >
    </span>
  </div>
</template>
